export default{
    data: [
        {
            "nom": "Loco Local",
            "avatar": "logo-loco-horizontal-initiale.png",
            "telephone": "581-630-0058"
        }
    ]
}
